<template>
  <v-select
    :items="trackingUnits"
    v-model="trackingUnit"
    outlined
    :dense="dense"
    hide-details="auto"
    :rules="rules"
    style="max-width: 15em"
  ></v-select>
</template>

<script>
import { PART_UNIT_NAMES } from '../../utils/PartUnits';

export default {
  name: 'TrackingUnitSelect',

  props: {
    value: {
      required: true,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    dense: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    trackingUnit: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
        this.$emit('change', value);
      },
    },

    trackingUnits() {
      return PART_UNIT_NAMES.map((trackingUnitName, index) => {
        return {
          text: this.$options.filters.unit(trackingUnitName),
          value: index + 1,
        };
      });
    },
  },
};
</script>
